<script>
	import Loader from './../../components/Modal/Loader.svelte';
    import { orders } from "./../../stores/orders.js";
    import { navigate } from "svelte-routing";
    import Swal from "sweetalert2";
    import axios from "axios";
    import Breadcrumb from "../../components/Breadcrumb.svelte";
    import Analytics from "../../components/Analytics.svelte";
    let waitforResponse = false;
    let semail = "";
    let uname = "";
    let instaname = "";
    let papertypes = [];
    let arttypes = [];
    let facetypes = [];
    let deliveryes = [];
    let arttypeselected = "";
    let faceselected = "";
    let papertypeselected = "";
    let deliveryselected = "";

    $: arttypeselected, getartTypes();
    $: faceselected, getFaceSelect();
    $: papertypeselected, getpaperType();
    $: deliveryselected, getdeliveryList();

    // $: instaname,
	// 	(() => {
	// 		findInstaProfile();
	// 	})();
    // function findInstaProfile(){
    //     orders.findUser(instaname).then((res)=>{
    //         console.log("instaname::"+JSON.stringify(res));
    //     })
    // }

    let getartTypes = () => {
        orders.getArtType().then((res) => {
            arttypes = res;
        });
    };
    let getFaceSelect = () => {
        orders.getAdditionalFaces().then((res) => {
            facetypes = res;
        });
    };
    let getpaperType = () => {
        orders.getPaperType().then((res) => {
            papertypes = res;
        });
    };
    let getdeliveryList = () => {
        orders.getDelivery().then((res) => {
            deliveryes = res;
        });
    };

    let welcomemail={};
    function submit() {
        waitforResponse = true;
        welcomemail.papertype = papertypeselected;
        welcomemail.arttype = arttypeselected;
        welcomemail.faces = faceselected;
        welcomemail.delivery = deliveryselected;
        console.log("welcomemail::Payload::" + JSON.stringify(welcomemail));
        orders.welcomeMail(welcomemail).then((res) => {
            console.log("&&&&&response:::" + res);
            if (res.message == "sentMail") {
                waitforResponse = false;
                Swal.fire("Success", "Successfully sent the mail", "success");
            } else {
                waitforResponse = false;
                Swal.fire(
                    "Oops...",
                    "Unable to send the mail Something went wrong!",
                    "error"
                );
            }
        });
    }
</script>
<svelte:head>
    <link
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.0-beta2/dist/css/bootstrap.min.css"
        rel="stylesheet"
    />
</svelte:head>
<Loader loading={waitforResponse} />
<Breadcrumb
    PreviousPage="Dashboard"
    title="welcome Mail"
    path="orders-dashboard"
/>
<div class="container-fluid">
    <Analytics />
    <!-- <OrderList /> -->
    <!-- <Unimportant /> -->
</div>

<form on:submit|preventDefault={submit}>
    <div class="row">
        <div class="col-sm">
            <label for="">Enquery Name <span class="text-danger">*</span></label
            >
            <input
                class="form-control"
                bind:value={welcomemail.name}
                type="text"
                placeholder="Person Name"
                required
            />
        </div>
        <div class="col-sm">
            <label for="">Email <span class="text-danger">*</span></label>
            <input
                class="form-control"
                bind:value={welcomemail.email}
                type="email"
                placeholder="user@example.com"
                required
            />
        </div>
        <div class="col-sm">
            <label for=""
                >Instagram Username <span class="text-danger">*</span></label
            >
            <input
                class="form-control"
                bind:value={welcomemail.instaname}
                type="text"
                placeholder="username"
                required
            />
        </div>
    </div>

    <div class="row">
        <div class="col-sm">
            <label for="">Paper Types</label>
            <select
                class="form-select"
                bind:value={papertypeselected}
                name=""
                id=""
                required
            >
                <option value="" disabled selected>Select</option>
                {#each papertypes as papertype}
                    <option
                        value={papertype.name}
                        selected={papertypeselected === papertype.name}
                        >{papertype.name}</option
                    >
                {/each}
            </select>
        </div>
        <div class="col-sm">
            <label for="">Art Types</label>
            <select
                class="form-select"
                bind:value={arttypeselected}
                name=""
                id=""
                required
            >
                <option value="" disabled selected>Select</option>
                {#each arttypes as arttype}
                    <option
                        value={arttype.name}
                        selected={arttypeselected === arttype.name}
                        >{arttype.name}</option
                    >
                {/each}
            </select>
        </div>
    </div>

    <div class="row">
        <div class="col-sm">
            <label for="">Additional Faces</label>
            <select
                class="form-select"
                bind:value={faceselected}
                name=""
                id=""
                required
            >
                <option value="" disabled selected>Select</option>
                {#each facetypes as facetype}
                    <option
                        value={facetype.name}
                        selected={faceselected === facetype.name}
                        >{facetype.name}</option
                    >
                {/each}
            </select>
        </div>
        <div class="col-sm">
            <label for="">Delivery Area</label>
            <select
                class="form-select"
                bind:value={deliveryselected}
                name=""
                id=""
            >
                <option value="" disabled selected>Select</option>
                {#each deliveryes as delivery}
                    <option
                        value={delivery.name}
                        selected={deliveryselected === delivery.name}
                        >{delivery.name}</option
                    >
                {/each}
            </select>
        </div>
    </div>
    <div class="pt-3">
        <button class="btn btn-success">Submit</button>
    </div>
</form>

<style>
    form {
        padding: 20px;
    }
    label {
        margin: 15px 0 5px 0;
        font-weight: 500;
    }
    .btn {
        min-width: 200px;
        font-weight: 500;
    }

    @media (max-width: 480px) {
        .btn {
            width: 100%;
        }
    }
</style>
